import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lib/i18n';
import App from './App';

// Capture arsheef_token before React tree runs, then remove it from visible URL early
// to reduce exposure via copy/paste/history/referrer on subsequent navigation.
if (typeof window !== 'undefined') {
  try {
    const params = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
    const token = params.get('arsheef_token') || hashParams.get('arsheef_token');
    if (token && token.trim()) {
      sessionStorage.setItem('ydim_arsheef_token_pending', token.trim());
      params.delete('arsheef_token');
      hashParams.delete('arsheef_token');
      const cleanSearch = params.toString();
      const cleanHash = hashParams.toString();
      const cleanUrl =
        window.location.pathname +
        (cleanSearch ? `?${cleanSearch}` : '') +
        (cleanHash ? `#${cleanHash}` : '');
      window.history.replaceState({}, '', cleanUrl || window.location.pathname);
      console.log('[FirmMode] Bootstrap: integration token captured and removed from URL');
    }
  } catch (e) {
    // ignore
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
//